import React from "react";
import styles from "./OfferHistory.module.scss";
import OfferHistoryItem from "./OfferHistoryItem";
import BackBar from "../../../common/nav/BackBar";
import SupportSelena from "../../../common/mypage/user-settings/SupportSelena";
import DBListPager from "../../../common/db-list/DBListPager";
import { genDisplayCount } from "../../../utils/GeneralUtils";
import ArchiveResultCounter from "../../../common/archive/ArchiveResultCounter";
import { SonicOfferData } from "../../../common/classes/SonicOffer";
import LoadingSpinner from "../../../common/LoadingSpinner";
import { SonicOfferMetaData } from "../../../common/classes/SonicOfferMeta";
import { PageVisibility } from "../../../utils/PageVisibility";

type Props = {
  ownUserId: string;
  offers: Array<SonicOfferData>;
  meta: Array<SonicOfferMetaData>;
  totalEntries: number;
  currentPage: number;
  totalPages: number;
  isLoading: boolean;
};
const OfferHistory: React.FC<Props> = ({
  ownUserId,
  offers,
  meta,
  totalEntries,
  currentPage,
  totalPages,
  isLoading,
}) => {
  return (
    <div className={styles["offer-history-wrap"]}>
      <BackBar
        title={"オファー履歴"}
        editable={false}
        handleClose={() => history.back()}
      />
      <div className={styles["offer-history"]}>
        <SupportSelena
          support_text={`プロフィールへのオファー【送信/受信】内容をご確認いただけます。`}
        />

        {isLoading ? (
          <LoadingSpinner space={1} />
        ) : (
          <>
            {offers.map((offer, i) => (
              <OfferHistoryItem
                key={offer.id}
                isRecipient={ownUserId === offer.recipient_account}
                timestamp={offer.timestamp}
                contentId={
                  meta[i].content_status === PageVisibility.PubliclyVisible
                    ? offer.to
                    : undefined
                }
                contentName={meta[i].to}
                senderId={offer.from}
                senderName={meta[i].from.name}
                offerType={offer.type}
                question={offer.message}
                otherReasons={offer.other_reasons}
              />
            ))}
            <ArchiveResultCounter
              current={genDisplayCount(
                currentPage,
                totalPages,
                10,
                totalEntries
              )}
              total={totalEntries}
            />
          </>
        )}

        <DBListPager
          totalPage={totalPages}
          currentPage={currentPage}
          shouldScrollToTop={true}
        />
      </div>
    </div>
  );
};

export default OfferHistory;
